import { render, staticRenderFns } from "./cms-subheader.vue?vue&type=template&id=be40633c&scoped=true&"
import script from "./cms-subheader.vue?vue&type=script&lang=js&"
export * from "./cms-subheader.vue?vue&type=script&lang=js&"
import style0 from "./cms-subheader.vue?vue&type=style&index=0&id=be40633c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be40633c",
  null
  
)

export default component.exports